import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";

/** The card a sidebar entry sits on, shared by every card entry so they match. */
export const SIDEBAR_CARD = "rounded-lg border bg-card p-3";

/** The button inside {@link SIDEBAR_CARD}. */
export const SIDEBAR_CARD_BUTTON =
	"!px-1 h-auto w-full justify-start gap-2 py-1.5";

/**
 * A sidebar entry on its own card, as Broadcast Controls is drawn. Collapsed,
 * it is an icon button named by its label, with the label as its tooltip.
 */
export function SidebarCardButton({
	icon: Icon,
	label,
	onClick,
	collapsed = false,
}: {
	icon: LucideIcon;
	label: string;
	onClick: () => void;
	collapsed?: boolean;
}) {
	if (collapsed) {
		return (
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						aria-label={label}
						className="size-9"
						onClick={onClick}
						size="icon"
						variant="ghost"
					>
						<Icon className="size-4" />
					</Button>
				</TooltipTrigger>
				<TooltipContent side="right">{label}</TooltipContent>
			</Tooltip>
		);
	}

	return (
		<div className={SIDEBAR_CARD}>
			<Button className={SIDEBAR_CARD_BUTTON} onClick={onClick} variant="ghost">
				<Icon className="size-3.5" />
				<span className="font-medium text-sm">{label}</span>
			</Button>
		</div>
	);
}
